"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfManageDigestSectionDto = instanceOfManageDigestSectionDto;
exports.ManageDigestSectionDtoFromJSON = ManageDigestSectionDtoFromJSON;
exports.ManageDigestSectionDtoFromJSONTyped = ManageDigestSectionDtoFromJSONTyped;
exports.ManageDigestSectionDtoToJSON = ManageDigestSectionDtoToJSON;
exports.ManageDigestSectionDtoToJSONTyped = ManageDigestSectionDtoToJSONTyped;
var ManageDigestPillDto_1 = require("./ManageDigestPillDto");
/**
 * Check if a given object implements the ManageDigestSectionDto interface.
 */
function instanceOfManageDigestSectionDto(value) {
    if (!('stepId' in value) || value['stepId'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    if (!('pills' in value) || value['pills'] === undefined)
        return false;
    return true;
}
function ManageDigestSectionDtoFromJSON(json) {
    return ManageDigestSectionDtoFromJSONTyped(json, false);
}
function ManageDigestSectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'stepId': json['stepId'],
        'label': json['label'],
        'pills': (json['pills'].map(ManageDigestPillDto_1.ManageDigestPillDtoFromJSON)),
    };
}
function ManageDigestSectionDtoToJSON(json) {
    return ManageDigestSectionDtoToJSONTyped(json, false);
}
function ManageDigestSectionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'stepId': value['stepId'],
        'label': value['label'],
        'pills': (value['pills'].map(ManageDigestPillDto_1.ManageDigestPillDtoToJSON)),
    };
}
